export enum EAuthenticationProviders {
  UNDEFINED = 'undefined',
  GOOGLE = 'google',
  LINKEDIN = 'linkedin',
  X = 'x',
  MAGIC_SIGN_IN = 'magic_sign_in',
}
